// App Imports
import { modalShow } from '../modules/common/api/actions';
import { API_WEBSOCKET_URL } from './config/env';
import io from "socket.io-client";
import { getTokenFromCookie } from '../modules/user/api/actions/query';

const AUTO_RECONNECT_INTERVAL = 1000; 
const ORDER_CREATED = 'order.created';
const QR_ORDER_UPDATED = 'qr-order.updated';
const TABLE_RESERVED = 'table.reserved';
const EMAIL_CAMPAIGN = "email.campaign.completed";
let store = null;
let socket = null;

export const connectToWebSocket = reduxStore => {
    store = reduxStore;
    connect();
};

export function disconnectWebSocket() {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
}

const connect = () => {
    const token = getTokenFromCookie();
    if (!token) return;

    const socketOptions = {
        path: '/ws/dashboard',
        query: {
            token,
            origin: typeof window !== 'undefined' ? window.location.origin : '',
            hostname: typeof window !== 'undefined' ? window.location.hostname : '',
        },
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: AUTO_RECONNECT_INTERVAL,
        reconnectionAttempts: Infinity,
    };

    socket = io(API_WEBSOCKET_URL, socketOptions);

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('error', onError);
    socket.on('message', onMessage);
};

const onConnect = () => {
    console.log('[wsocket] Connection established. Socket id:', socket?.id);
    if (typeof window !== 'undefined' && socket) {
        socket.emit('join', window.location.hostname);
        socket.emit('join', window.location.origin);
    }
};

const onDisconnect = () => {
    console.log('Disconnected from server.');
};

const onError = error => {
    console.error('WebSocket error:', error);
};

const onMessage = message => {
    console.log('[wsocket] Raw message received:', message);
    try {
        eventHandler(JSON.parse(message));
    } catch (err) {
        console.error('Error parsing message:', err);
    }
};

const playAudio = (soundId, loop) => {
    console.log(`[playAudio] Attempting to play soundId="${soundId}" loop=${loop}`);
    const audio = document.getElementById(soundId);
    if (!audio) {
        console.error(`[playAudio] ERROR: No <audio> element found with id="${soundId}". Is Layout mounted?`);
        return;
    }
    console.log(`[playAudio] Audio element found. src="${audio.src}" readyState=${audio.readyState} paused=${audio.paused}`);
    audio.loop = loop;
    const playPromise = audio.play();
    if (playPromise !== undefined) {
        playPromise
            .then(() => console.log(`[playAudio] Playback started successfully for "${soundId}"`))
            .catch(err => console.error(`[playAudio] play() was blocked for "${soundId}":`, err));
    }
    if (loop) {
        setTimeout(() => {
            console.log(`[playAudio] Auto-stopping looping sound "${soundId}" after 30s`);
            audio.pause();
            audio.currentTime = 0;
            audio.loop = false;
        }, 30000);
    }
  };
  
const eventHandler = ({ event, payload }) => {
    console.log(`[wsocket] eventHandler received event="${event}"`, payload);
    const notifications = JSON.parse(localStorage.getItem("notifications")) || [];

    switch (event) {
        case ORDER_CREATED:
            console.log(`[wsocket] ORDER_CREATED: orderFrom="${payload?.orderFrom}"`);
            notifications.push({ event, payload });
            localStorage.setItem("notifications", JSON.stringify(notifications));
            store.dispatch(modalShow({ title: 'You have New Orders...!', text: `Order ID: ${payload?.id}`}));
            if (payload?.orderFrom === "instore") {
              console.log('[wsocket] Playing sound2 (instore order, no loop)');
              playAudio("sound2", false);
            } else {
              console.log('[wsocket] Playing sound (online order, loop)');
              playAudio("sound", true);
            }

            document.getElementById('refreshLiveOrders')?.click();
           
            if (window.headerComponentInstance) {
                window.headerComponentInstance.setState({ notifications });
            }
            break;
        case QR_ORDER_UPDATED:
            console.log(`[wsocket] QR_ORDER_UPDATED: orderId="${payload?.orderId}"`);
            notifications.push({ event, payload });
            localStorage.setItem("notifications", JSON.stringify(notifications));
            store.dispatch(modalShow({ title: 'QR Order Updated...!', text: `Order ID: ${payload?.orderId}`}));
            console.log('[wsocket] Playing sound2 (QR order, no loop)');
            playAudio("sound2", false);
            document.getElementById('refreshLiveOrders')?.click();
            if (window.headerComponentInstance) {
                window.headerComponentInstance.setState({ notifications });
            }
            break;
        case TABLE_RESERVED:
            console.log('[wsocket] TABLE_RESERVED');
            notifications.push({ event, payload });
            localStorage.setItem("notifications", JSON.stringify(notifications));
            store.dispatch(modalShow({ title: null, text: 'A New Table has been Booked!' }));
            console.log('[wsocket] Playing sound (table reserved, loop)');
            playAudio("sound", true);
            if (window.location.pathname === '/table-bookings') {
                document.getElementById('refreshReservations')?.click();
            }
            if (window.headerComponentInstance) {
                window.headerComponentInstance.setState({ notifications });
            }
            break;
        case EMAIL_CAMPAIGN:
            console.log(`[wsocket] EMAIL_CAMPAIGN: status="${payload?.status}"`);
            if (payload.status === "Completed") {
                notifications.push({ event, payload });
                localStorage.setItem("notifications", JSON.stringify(notifications));
            }

            const { eventName, status, totalSent } = payload;

            store.dispatch(modalShow({title: "Email Marketing", text: `Event: ${eventName} is ${status}${status === "Completed" ? `, Total emails sent: ${totalSent}` : ''}`}));
            if (window.location.pathname === "/messaging" && status === "Completed") {
                setTimeout(()=>
                    window.location.reload()
                , 3000)
            }
            if (window.headerComponentInstance && status === "Completed") {
                window.headerComponentInstance.setState({ notifications });
            }
            break;
        default:
            console.warn(`[wsocket] Unhandled event type: "${event}"`);
            break;
    }
};

export {socket}